<div  class="text-empty-content-valign">
    <div >{{primaryText}}</div>
</div>